var _ellipse, _path, _ellipse2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAsistentJourney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 655,
    viewBox: "0 0 47 655",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 51.1915,
    cy: 82.5166,
    rx: 51.1915,
    ry: 82.5166,
    transform: "matrix(-1 0 0 1 34.5483 -125.07)",
    fill: "#14257A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M-90.9851 -42.5527C-90.9851 -8.07047 -82.3046 22.918 -68.5242 45.1308C-54.6989 67.4162 -36.2256 80.2257 -16.6433 80.2257C2.93886 80.2257 21.4122 67.4162 35.2375 45.1308C49.0179 22.918 57.6984 -8.07047 57.6984 -42.5527C57.6984 -77.035 49.0179 -108.023 35.2375 -130.236C21.4122 -152.522 2.93886 -165.331 -16.6433 -165.331C-36.2256 -165.331 -54.6989 -152.522 -68.5242 -130.236C-82.3046 -108.023 -90.9851 -77.035 -90.9851 -42.5527Z",
    stroke: "#050B2B",
    strokeWidth: 9.62672
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 51.1915,
    cy: 82.5166,
    rx: 51.1915,
    ry: 82.5166,
    transform: "matrix(-1 0 0 1 71.6816 444.254)",
    fill: "#14257A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M-58.4924 526.721C-58.4924 561.613 -49.7141 593.097 -35.6371 615.788C-21.5396 638.512 -2.34877 652.125 18.4748 652.125C39.2984 652.125 58.4893 638.512 72.5867 615.788C86.6637 593.097 95.442 561.613 95.442 526.721C95.442 491.829 86.6637 460.344 72.5867 437.653C58.4893 414.929 39.2984 401.317 18.4748 401.317C-2.34877 401.317 -21.5396 414.929 -35.6371 437.653C-49.7141 460.344 -58.4924 491.829 -58.4924 526.721Z",
    stroke: "#050B2B",
    strokeWidth: 4.37578
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsistentJourney);
export default __webpack_public_path__ + "static/media/asistentJourney.d9ed607446bb0be74f2d1badb45ae9ad.svg";
export { ForwardRef as ReactComponent };